<template>
  <div class="p-6 bg-white rounded-lg">
    <h3 class="text-2xl font-medium mb-4 pb-2 border-b">
      New Order
    </h3>

    <p class="text-base leading-tight mb-6">
      Click the button below to create a new Gold Marketing Pack order.
    </p>

    <button
      type="submit"
      class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
      @click="createOrder"
    >
      <loader :fillColor="'black'" v-if="loading" />
      <span v-else>Create New Order</span>
    </button>
  </div>
</template>

<script>
import api from '@/http'
import { mapState, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    createOrder: function () {
      this.loading = true

      api.get('/legacy-members-hub/login', {
        params: {
          office_id: this.selectedOffice.id,
          redirect: '/forms/gold-service'
        }
      }).then((response) => {
        this.loading = false
        window.open(response.data.url)
      }, () => {
        this.loading = false
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Gold Marketing Pack',
          info: 'Sorry, we\'re unable to log you into the old members hub right now. Please try again later.'
        })
      })
    }
  }
}
</script>
